import ipadOsIcon from '@/assets/device-icons/ipad-os.svg';

interface IpadOsIconProps {
  className?: string;
}

export const IpadOsIcon = ({ className = "h-5 w-5" }: IpadOsIconProps) => {
  return (
    <img 
      src={ipadOsIcon} 
      alt="iPadOS" 
      className={className}
    />
  );
};
